<!-- <div class="top">0</div> -->
<audio id="audioSection" controls autoplay loop hidden="hidden">
	<source autoplay="true" src="../../assets/audio/energy.mp3" type="audio/mp3">
	<!-- Your browser does not support the audio element. -->
</audio>
<div class="car">
	<img id="carOutside" class="car responsive-img" src="/assets/img/how/desktop/first/withoutcar.png" alt="">
</div>

<div class="road hide-on-med-and-down">
	<div class="container road1">
		<div class="row firstText animated hide" id="text1">
			<div class="col s10 offset-s1 m8 offset-m2 l6">
				<!-- large -->
				<h3 class="hide-on-med-and-down">La necesidad de trasladar y dar visibilidad a negocios en medios digitales es inevitable</h3>
			</div>
		</div>
		
		<!-- dunes -->
		<img data-speed="10" class="responsive-img parallaxHow base zBack" src="/assets/img/how/desktop/first/dune3.png">
		<img data-speed="4" class="responsive-img parallaxHow base zFront" src="/assets/img/how/desktop/first/dune1.png">
		
		<!-- car -->
		<img class="firstCar carInside responsive-img" src="/assets/img/how/desktop/first/car.png" alt="">
		<!-- <img class="carInside responsive-img zFront" src="/assets/img/how/desktop/first/car.png" alt=""> -->
		<div class="floor"></div>
	</div>
	<div class="container road2">
		<div class="row secondText animated hide" id="text2">
			<div class="col s10 offset-s1 m8 offset-m2 l6">
				<!-- large -->
				<h3 class="hide-on-med-and-down">tu idea se enriquecerá y llevará a cabo a mano de los mejores profesionales</h3>
				<!-- medium -->
				<h4 class="hide-on-large-only hide-on-small-only">tu idea se enriquecerá y llevará a cabo a mano de los mejores profesionales</h4>
				<!-- small -->
			</div>
		</div>
		<!-- dunes -->
		<img data-speed="3" class="responsive-img parallaxHow base zBack" src="/assets/img/how/desktop/second/dune3.png">
		<img data-speed="8" class="responsive-img parallaxHow base zFront" src="/assets/img/how/desktop/second/dune2.png">
		<img data-speed="15" class="responsive-img parallaxHow base zFront" src="/assets/img/how/desktop/second/dune1.png">

		<!-- car -->
		<img class="secondCar carInside responsive-img" src="/assets/img/how/desktop/first/car.png" alt="">

		<!-- temple -->
		<img data-speed="6" class="responsive-img parallaxHow base zFront" src="/assets/img/how/desktop/second/temple.png">

		<div class="floor"></div>
	</div>
	<div class="container road3">
		<div class="row thirdText animated hide" id="text3">
			<div class="col s10 offset-s1 m8 offset-m2 l6">
				<h3 class="hide-on-med-and-down">Entra y descubre la energía que nos mueve a relizar todo lo que encontrarás con nosotros</h3>
				<h4 class="hide-on-large-only hide-on-small-only">Entra y descubre la energía que nos mueve a relizar todo lo que encontrarás con nosotros</h4>
			</div>
		</div>
		<!-- dunes -->
		<img data-speed="8" class="responsive-img parallaxHow base zFront" src="/assets/img/how/desktop/third/dune2.png">
		<img data-speed="3" class="responsive-img parallaxHow base zFront" src="/assets/img/how/desktop/third/dune1.png">

		<!-- pyramid -->
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/third/pyramid.png">
		
		<!-- car -->
		<img class="thirdCar carInside responsive-img" src="/assets/img/how/desktop/first/car.png" alt="">

		<div class="floor"></div>
	</div>
	<div class="container road4">
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/fourth/pyramid.png">

		<!-- shadows -->
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/fourth/shadow1.png">
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/fourth/shadow2.png">

		<!-- palmiforme -->
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/fourth/palmiforme.png">
		<!-- car -->
		<img class="fourthCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		<div class="floor"></div>
	</div>
	<div class="container road5">
		<div class="row fourthText animated hide" id="text4">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l6">
				<h3 class="hide-on-med-and-down">La llama que nos ilumina el camino es la curiosidad y creatividad</h3>
				<h4 class="hide-on-large-only hide-on-small-only">La llama que nos ilumina el camino es la curiosidad y creatividad</h4>
			</div>
		</div>

		<div class="floor"></div>
		
		<!-- light -->
		<img data-speed="0" class="responsive-img left l1 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/l4.png">
		<img data-speed="0" class="responsive-img left l2 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/l3.png">
		<img data-speed="0" class="responsive-img left l3 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/l2.png">
		<img data-speed="0" class="responsive-img left l4 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/l1.png">
		
		<!-- flames -->
		<img data-speed="0" class="responsive-img left f1 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/4.png">
		<img data-speed="0" class="responsive-img left f2 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/3.png">
		<img data-speed="0" class="responsive-img left f3 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/2.png">
		<img data-speed="0" class="responsive-img left f4 parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/1.png">
		
		<!-- stick -->
		<img data-speed="0" class="responsive-img left parallaxHow base zFront" src="/assets/img/how/desktop/fiveth/stick.png">

		<!-- reflections -->
		<img data-speed="0" class="responsive-img left lightReflection1 parallaxZero base zFront" src="/assets/img/how/desktop/fiveth/lf2.png">
		<img data-speed="0" class="responsive-img left lightReflection2 parallaxZero base zFront" src="/assets/img/how/desktop/fiveth/lf1.png">

		<!-- car -->
		<img class="fivethCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">

	</div>
	<div class="container road6">

		<div class="row fourthText animated hide" id="text5">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l6">
				<h3 class="hide-on-med-and-down">La inspiración es nuestro centro creativo fuertemente protegido por experiencia y conocimiento</h3>
				<h4 class="hide-on-large-only hide-on-small-only">La inspiración es nuestro centro creativo fuertemente protegido por experiencia y conocimiento</h4>
			</div>
		</div>

		<div class="floor zBack"></div>
		
		<!-- car -->
		<img class="sixthCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		
		<!-- palmis -->
		<img data-speed="-.3" class="responsive-img left parallaxZero base zBack toStretch" src="/assets/img/how/desktop/sixth/p2.png">
		
		
		<!-- palmi -->
		<img data-speed="-.8" class="responsive-img left parallaxZero base zFront toStretch" src="/assets/img/how/desktop/sixth/p1.png">

	</div>
	<div class="container road7">
		<div class="row fourthText animated hide" id="text5-6">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l6">
				<h4 class="hide-on-large-only hide-on-small-only">
					la llama sigue prendida en todo el proceso de creación porque amamos lo que hacemos
				</h4>
			</div>
		</div>
		<div class="floor zBack"></div>
		<!-- car -->
		<img class="seventhCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		<!-- anubis -->
		<img data-speed="0" class="responsive-img left parallaxZero base zFront" src="/assets/img/how/desktop/seventh/a1.png">
		<img data-speed="0" class="responsive-img left parallaxZero base zFront al1" src="/assets/img/how/desktop/seventh/l1.png">

		<!-- light -->
		<div class="lightEnergy">
			<img data-speed="0" class="responsive-img l1 parallaxZero base zFront" src="/assets/img/how/desktop/seventh/le4.png">
			<img data-speed="0" class="responsive-img l2 parallaxZero base zFront" src="/assets/img/how/desktop/seventh/le3.png">
			<img data-speed="0" class="responsive-img l3 parallaxZero base zFront" src="/assets/img/how/desktop/seventh/le2.png">
			<img data-speed="0" class="responsive-img l4 parallaxZero base zFront" src="/assets/img/how/desktop/seventh/le1.png">
		</div>
		
		<!-- anubis -->
		<img data-speed="0" class="responsive-img right parallaxZero base zFront" src="/assets/img/how/desktop/seventh/a2.png">
		<img data-speed="0" class="responsive-img left parallaxZero base zFront al1" src="/assets/img/how/desktop/seventh/l2.png">

		<!-- energy -->
		<img data-speed="0" class="responsive-img energy parallaxZero base zFront" src="/assets/img/how/desktop/seventh/energy.png">
		<img data-speed="0" class="responsive-img energy parallaxZero base zFront" src="/assets/img/how/desktop/seventh/shadowsEnergy.png">
		<img data-speed="0" class="responsive-img energy parallaxZero base zFront" src="/assets/img/how/desktop/seventh/lightEnergy.png">
		

		<!-- elixir -->
		<img data-speed="0" class="responsive-img left parallaxZero base zFront" src="/assets/img/how/desktop/seventh/font.png">
		<img data-speed="0" class="responsive-img left eli1 parallaxZero base zFront" src="/assets/img/how/desktop/seventh/fl.png">

	</div>
	<div class="container road8">
		<div class="row fivethText animated hide" id="text6">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l6">
				<h3 class="hide-on-med-and-down">
					la llama sigue prendida en todo el proceso de creación porque amamos lo que hacemos
				</h3>
			</div>
		</div>

		<div class="floor zBack"></div>
		
		<!-- light -->
		<img data-speed="0" class="responsive-img  l1 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/l4.png">
		<img data-speed="0" class="responsive-img  l2 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/l3.png">
		<img data-speed="0" class="responsive-img  l3 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/l2.png">
		<img data-speed="0" class="responsive-img  l4 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/l1.png">
		
		<!-- flames -->
		<img data-speed="0" class="responsive-img  f1 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/4.png">
		<img data-speed="0" class="responsive-img  f2 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/3.png">
		<img data-speed="0" class="responsive-img  f3 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/2.png">
		<img data-speed="0" class="responsive-img  f4 parallaxHow base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/1.png">
		
		<!-- stick -->
		<img data-speed="0" class="responsive-img  parallaxHow base zFront rightWithValue" src="/assets/img/how/desktop/fiveth/stick.png">
		
		<!-- reflections -->
		<img data-speed="0" class="responsive-img  lightReflection1 parallaxZero base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/lf2.png">
		<img data-speed="0" class="responsive-img  lightReflection2 parallaxZero base rightWithValue zFront" src="/assets/img/how/desktop/fiveth/lf1.png">
		
		<!-- car -->
		<img class="eightCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		
		<!-- palmi -->
		<img data-speed="-.8" class="responsive-img left parallaxZero base zFront toStretch" src="/assets/img/how/desktop/sixth/p2.png">

	</div>
	<div class="container road9">
		<div class="row fourthText animated hide" id="text7">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
				<h3 class="hide-on-med-and-down">siempre la estructura de nuestros procesos con buenas bases hasta el final</h3>
				<h4 class="hide-on-large-only hide-on-small-only">siempre la estructura de nuestros procesos con buenas bases hasta el final</h4>
			</div>
		</div>
		<div class="floor zBack"></div>
		<!-- car -->
		<img class="ninethCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/nineth/pyramid.png">
		
		<!-- shadows -->
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/nineth/shadow1.png">
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/nineth/shadow2.png">
		
		<!-- palmiforme -->
		<img data-speed="0" class="responsive-img parallaxHowZro base zFront toStretch" src="/assets/img/how/desktop/nineth/papiforme.png">
	</div>
	<div class="container road10">
		<div class="row firstText animated hide" id="text8">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
				<h3 class="hide-on-med-and-down">la riqueza visual y nuestra atención en los detalles harán de tu proyecto algo único </h3>
				<h4 class="hide-on-large-only hide-on-small-only">la riqueza visual y nuestra atención en los detalles harán de tu proyecto algo único </h4>
			</div>
		</div>
		
		<!-- dunes -->
		<img data-speed="" class="responsive-img parallaxHow base zBack" src="/assets/img/how/desktop/tenth/dune2.png">
		<!-- <img data-speed="" class="responsive-img parallaxHow base zBack" src="/assets/img/how/desktop/tenth/dune1.png"> -->
		
		<!-- pyramid -->
		<img data-speed="0" class="responsive-img parallaxHow base zFront toStretch" src="/assets/img/how/desktop/tenth/pyramid.png">
		
		
		<!-- car -->
		<img class="tenthCar carInside responsive-img zFront" src="/assets/img/how/desktop/tenth/car.png" alt="">

		<div class="floor"></div>
	</div>

	<div class="container road10">

		<div class="row firstText animated hide" id="text9">
			<div class="col s10 offset-s1 m8 offset-m2 l6 offset-l5">
				<h3 class="hide-on-med-and-down">gracias por llegar hasta aquí y ver lo que podemos hacer</h3>
				<h4 class="hide-on-large-only hide-on-small-only">gracias por llegar hasta aquí y ver lo que podemos hacer</h4>
			</div>
		</div>

		<!-- dunes -->
		<img data-speed="" class="responsive-img parallaxZero base zBack" src="/assets/img/how/desktop/eleventh/d1.png">	
		<img data-speed="" class="responsive-img parallaxZero base zBack" src="/assets/img/how/desktop/eleventh/d2.png">
		
		<!-- lake -->
		<!-- <img data-speed="" class="responsive-img parallaxZero base zFront" src="/assets/img/how/desktop/eleventh/lake.png"> -->

		<!-- trees -->
		<img data-speed="" class="responsive-img parallaxZero base zFront" src="/assets/img/how/desktop/eleventh/trees.png">

		<!-- lake -->
		<img data-speed="" class="responsive-img parallaxZero base zFront lakeOne" src="/assets/img/how/desktop/eleventh/lake1.png">
		<img data-speed="" class="responsive-img parallaxZero base zFront lakeTwo" src="/assets/img/how/desktop/eleventh/lake2.png">
		<img data-speed="" class="responsive-img parallaxZero base zFront lakeThree" src="/assets/img/how/desktop/eleventh/lake3.png">
		
		<!-- rocks -->
		<img data-speed="" class="responsive-img parallaxZero base zFront" src="/assets/img/how/desktop/eleventh/rocks.png">

		<img data-speed="" class="responsive-img parallaxZero base zFront" src="/assets/img/how/desktop/eleventh/way.png">

		<img data-speed="" class="responsive-img parallaxZero base zFront" src="/assets/img/how/desktop/eleventh/way.png">

		<!-- car -->
		<img class="eleventhCar carInside responsive-img zFront" src="/assets/img/how/desktop/tenth/car.png" alt="">
		<img class="responsive-img parallaxZero base zFront" src="/assets/img/how/desktop/eleventh/way2.png" alt="">

		<div class="floor light middle"></div>
	</div>
</div>

<div class="road-medium hide-on-large-only">
	<div class="container-medium roadM1">
        <!-- text -->
        <div class="row firstText animated hide" id="text1M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">la necesidad de trasladar y dar visibilidad a negocios en medios digitales es inevitable</h4>
                <h5 class="hide-on-med-and-up">la necesidad de trasladar y dar visibilidad a negocios en medios digitales es inevitable</h5>
            </div>
	    </div>
			
		<!-- dunes -->
		<img data-speed="4" class="responsive-img parallaxZero base left zBack upOfTheFloor" src="/assets/img/how/mobile/first/d1.png">
		<img data-speed="10" class="responsive-img parallaxZero base left zFront upOfTheFloor" src="/assets/img/how/mobile/first/d2.png">

		<!-- car -->
		<img class="firstCar carInside responsive-img" src="/assets/img/how/desktop/first/car.png" alt="">

		<!-- floor -->
		<div class="floorM"></div>
	</div>

	<div class="container-medium roadM2">
        <!-- text -->
        <div class="row secondText animated hide" id="text2M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">tu idea se enriquecerá y llevará a cabo a mano de los mejores profesionales</h4>
                <h5 class="hide-on-med-and-up">tu idea se enriquecerá y llevará a cabo a mano de los mejores profesionales</h5>
            </div>
        </div>
        
		<!-- dunes -->
		<img data-speed="1" class="responsive-img parallaxHow base left zFront upOfTheFloor" src="/assets/img/how/mobile/second/d2.png">
		<img data-speed="5" class="responsive-img parallaxHow base left zFront upOfTheFloor" src="/assets/img/how/mobile/second/d1.png">
		
		
		<!-- temple -->
		<img data-speed="1" class="responsive-img parallaxHow base zFront upOfTheFloor" src="/assets/img/how/mobile/second/temple.png">
		
		<!-- car -->
		<img class="secondCar carInside responsive-img" src="/assets/img/how/desktop/first/car.png" alt="">
		
		<!-- floor -->
		<div class="floorM"></div>
	</div>
	<div class="container-medium roadM3">
        <!-- text -->
        <div class="row thirdText animated hide" id="text3M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">Entra y descubre la energía que nos mueve a relizar todo lo que encontrarás con nosotros</h4>
                <h5 class="hide-on-med-and-up">Entra y descubre la energía que nos mueve a relizar todo lo que encontrarás con nosotros</h5>
            </div>
        </div>
		<!-- dunes -->
		<img data-speed="6" class="responsive-img parallaxHow base left zFront upOfTheFloor" src="/assets/img/how/mobile/thirth/d2.png">
		
		<!-- pyramid -->
		<img data-speed="0" class="responsive-img parallaxZero base zFront upOfTheFloor toStretch right" src="/assets/img/how/mobile/thirth/pyramid.png">
		
		<!-- car -->
		<img class="thirdCar carInside responsive-img" src="/assets/img/how/desktop/first/car.png" alt="">
		
		<!-- floor -->
		<div class="floorM"></div>
	</div>
	<div class="container-medium roadM4">
		<!-- shadow -->
		<img data-speed="0" class="responsive-img parallaxHow base left zFront upOfTheFloor toStretch" src="/assets/img/how/mobile/fourth/shadow.png">
		<!-- car -->
		<img class="fourthCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		<!-- pyramid -->
		<img data-speed="0" class="responsive-img parallaxHow base left zFront upOfTheFloor toStretch" src="/assets/img/how/mobile/fourth/pyramid2.png">
		

		
		<!-- floor -->
		<div class="floorM"></div>
	</div>
	<div class="container-medium roadM5">
		<!-- palmi -->
		<img data-speed="0" class="responsive-img parallaxZero base zFront upOfTheFloor right" src="/assets/img/how/mobile/fifth/palmiforme.png">
		
		<!-- car -->
		<img class="fivethCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		
		<!-- floor -->
		<div class="floorM"></div>
	</div>
	<div class="container-medium roadM6">
        <!-- text -->
        <div class="row fourthText animated hide" id="text4M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">La llama que nos ilumina el camino es la curiosidad y creatividad</h4>
                <h5 class="hide-on-med-and-up">La llama que nos ilumina el camino es la curiosidad y creatividad</h5>
            </div>
        </div>
		<div class="floorM"></div>
		
		<!-- light -->
		<img data-speed="0" class="responsive-img left l1 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l4.png">
		<img data-speed="0" class="responsive-img left l2 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l3.png">
		<img data-speed="0" class="responsive-img left l3 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l2.png">
		<img data-speed="0" class="responsive-img left l4 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l1.png">
		
		<!-- flames -->
		<img data-speed="0" class="responsive-img left f1 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/4.png">
		<img data-speed="0" class="responsive-img left f2 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/3.png">
		<img data-speed="0" class="responsive-img left f3 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/2.png">
		<img data-speed="0" class="responsive-img left f4 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/1.png">
		
		<!-- stick -->
		<img data-speed="0" class="responsive-img left parallaxHow base zFront" src="/assets/img/how/mobile/sixth/stick.png">

		<!-- reflections -->
		<img data-speed="0" class="responsive-img left lightReflection1 parallaxZero base zFront" src="/assets/img/how/mobile/sixth/lf2.png">
		<img data-speed="0" class="responsive-img left lightReflection2 parallaxZero base zFront" src="/assets/img/how/mobile/sixth/lf1.png">

		<!-- car -->
		<img class="sixthCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
	</div>
	<div class="container-medium roadM7">
        <!-- text -->
        <div class="row fourthText animated hide" id="text5M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">nuestra fuerza es custodiada por fuertes conocimientos</h4>
                <h5 class="hide-on-med-and-up">nuestra fuerza es custodiada por fuertes conocimientos</h5>
            </div>
        </div>
		<div class="floorM"></div>
		<!-- car -->
		<img class="seventhCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">

		<!-- anubis -->
		<img data-speed="0" class="responsive-img right parallaxZero base zFront anubis" src="/assets/img/how/mobile/seventh/a1.png">
		<img data-speed="0" class="responsive-img right parallaxZero base zFront al1 anubis" src="/assets/img/how/mobile/seventh/l1.png">

	</div>
	<div class="container-medium roadM8">
        <!-- text -->
        <div class="row fourthText animated hide" id="text6M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">La inspiración en nuestro centro creativo fuertemente protegido por experiencia y conocimiento</h4>
                <h5 class="hide-on-med-and-up">La inspiración en nuestro centro creativo fuertemente protegido por experiencia y conocimiento</h5>
            </div>
        </div>
		<div class="floorM"></div>
		<!-- car -->
		<img class="eightCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">

		<!-- light -->
		<div class="lightEnergy">
			<img data-speed="0" class="responsive-img l1 parallaxZero base zFront left" src="/assets/img/how/mobile/eight/le4.png">
			<img data-speed="0" class="responsive-img l2 parallaxZero base zFront left" src="/assets/img/how/mobile/eight/le3.png">
			<img data-speed="0" class="responsive-img l3 parallaxZero base zFront left" src="/assets/img/how/mobile/eight/le2.png">
			<img data-speed="0" class="responsive-img l4 parallaxZero base zFront left" src="/assets/img/how/mobile/eight/le1.png">
		</div>

		<!-- energy -->
		<img data-speed="0" class="responsive-img energy parallaxZero base zFront left" src="/assets/img/how/mobile/eight/energy.png">
		<img data-speed="0" class="responsive-img energy parallaxZero base zFront left" src="/assets/img/how/mobile/eight/shadowsEnergy.png">
		<img data-speed="0" class="responsive-img energy parallaxZero base zFront left" src="/assets/img/how/mobile/eight/lightEnergy.png">
		

		<!-- elixir -->
		<img data-speed="0" class="responsive-img left parallaxZero base zFront" src="/assets/img/how/mobile/eight/font.png">
		<img data-speed="0" class="responsive-img left eli1 parallaxZero base zFront" src="/assets/img/how/mobile/eight/fl.png">
	</div>
	<div class="container-medium roadM9">
        <!-- text -->
        <div class="row fourthText animated hide" id="text7M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">la convicción es nuestra mejor custodia de la innovación</h4>
                <h5 class="hide-on-med-and-up">la convicción es nuestra mejor custodia de la innovación</h5>
            </div>
        </div>
		<div class="floorM"></div>
		<!-- car -->
		<img class="ninethCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">

		<!-- anubis -->
		<img data-speed="0" class="responsive-img left parallaxZero base zFront anubis" src="/assets/img/how/mobile/nineth/a1.png">
		<img data-speed="0" class="responsive-img left parallaxZero base zFront al1 anubis" src="/assets/img/how/mobile/nineth/l1.png">
	</div>
	<div class="container-medium roadM10">
        <!-- text -->
        <div class="row fourthText animated hide" id="text8M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">la llama sigue prendida en todo el proceso de creación porque amamos lo que hacemos</h4>
                <h5 class="hide-on-med-and-up">la llama sigue prendida en todo el proceso de creación porque amamos lo que hacemos</h5>
            </div>
        </div>
		<div class="floorM"></div>
		
		<!-- light -->
		<img data-speed="0" class="responsive-img left l1 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l4.png">
		<img data-speed="0" class="responsive-img left l2 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l3.png">
		<img data-speed="0" class="responsive-img left l3 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l2.png">
		<img data-speed="0" class="responsive-img left l4 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/l1.png">
		
		<!-- flames -->
		<img data-speed="0" class="responsive-img left f1 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/4.png">
		<img data-speed="0" class="responsive-img left f2 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/3.png">
		<img data-speed="0" class="responsive-img left f3 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/2.png">
		<img data-speed="0" class="responsive-img left f4 parallaxHow base zFront" src="/assets/img/how/mobile/sixth/1.png">
		
		<!-- stick -->
		<img data-speed="0" class="responsive-img left parallaxHow base zFront" src="/assets/img/how/mobile/sixth/stick.png">

		<!-- reflections -->
		<img data-speed="0" class="responsive-img left lightReflection1 parallaxZero base zFront" src="/assets/img/how/mobile/sixth/lf2.png">
		<img data-speed="0" class="responsive-img left lightReflection2 parallaxZero base zFront" src="/assets/img/how/mobile/sixth/lf1.png">

		<!-- car -->
		<img class="tenthCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
	</div>
	<div class="container-medium roadM11">
        <div class="row fourthText animated hide" id="text9M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">siempre la estructura de nuestros procesos con buenas bases hasta el final</h4>
                <h5 class="hide-on-med-and-up">siempre la estructura de nuestros procesos con buenas bases hasta el final</h5>
            </div>
        </div>
		<!-- papi -->
		<img data-speed="0" class="responsive-img parallaxZero base zFront upOfTheFloor right" src="/assets/img/how/mobile/eleventh/papiforme.png">
		
		<!-- car -->
		<img class="eleventhCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		
		<!-- floor -->
		<div class="floorM"></div>
	</div>
	<div class="container-medium roadM12">
		
		<!-- shadow -->
		<img data-speed="0" class="responsive-img parallaxHow base right zFront upOfTheFloor toStretch" src="/assets/img/how/mobile/twelfth/shadow.png">
		
		<!-- car -->
		<img class="twelfthCar carInside responsive-img" src="/assets/img/how/desktop/fourth/car.png" alt="">
		
		<!-- pyramid -->
		<img data-speed="0" class="responsive-img parallaxHow base right zFront upOfTheFloor toStretch" src="/assets/img/how/mobile/twelfth/pyramid.png">
		
		<!-- floor -->
		<div class="floorM"></div>
	</div>
	<div class="container-medium roadM13">
        <div class="row fourthText animated hide" id="text10M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">la riqueza visual y nuestra atención en los detalles harán de tu proyecto algo único </h4>
                <h5 class="hide-on-med-and-up">la riqueza visual y nuestra atención en los detalles harán de tu proyecto algo único </h5>
            </div>
        </div>
		<!-- pyramid -->
		<img data-speed="0" class="responsive-img parallaxHow base left zFront upOfTheFloor toStretch" src="/assets/img/how/mobile/thirtenth/pyramid.png">
		
		<!-- car -->
		<img class="thirtenthCar carInside responsive-img" src="/assets/img/how/desktop/tenth/car.png" alt="">

		<!-- floor -->
		<div class="floorM light"></div>
	</div>
	<div class="container-medium roadM14">
        <div class="row fourthText animated hide" id="text11M">
            <div class="col s10 offset-s1 m8 offset-m2 l6">
                <h4 class="hide-on-large-only hide-on-small-only">gracias por llegar hasta aquí y ver lo que podemos hacer</h4>
                <h5 class="hide-on-med-and-up">gracias por llegar hasta aquí y ver lo que podemos hacer</h5>
            </div>
        </div>
		<!-- dunes -->
		<img data-speed="" class="responsive-img parallaxHow base upOfTheFloor right zBack" src="/assets/img/how/mobile/fourtenth/d2.png">
		<img data-speed="" class="responsive-img parallaxHow base upOfTheFloor right zBack" src="/assets/img/how/mobile/fourtenth/d1.png">	
		
		<!-- trees -->
		<img data-speed="" class="responsive-img parallaxHow base right zFront" src="/assets/img/how/mobile/fourtenth/trees.png">

		<!-- lake -->
		<img data-speed="" class="responsive-img parallaxHow base right zFront lakeOne" src="/assets/img/how/mobile/fourtenth/lake1.png">
		<img data-speed="" class="responsive-img parallaxHow base right zFront lakeTwo" src="/assets/img/how/mobile/fourtenth/lake2.png">
		<img data-speed="" class="responsive-img parallaxHow base right zFront lakeThree" src="/assets/img/how/mobile/fourtenth/lake3.png">
		
		<!-- rocks -->
		<img data-speed="" class="responsive-img parallaxHow base right zFront" src="/assets/img/how/mobile/fourtenth/rocks.png">
		
		<img data-speed="" class="responsive-img parallaxHow base right zFront" src="/assets/img/how/mobile/fourtenth/way.png">
		
		<!-- car -->
		<img class="fourtenthCar carInside responsive-img zFront" src="/assets/img/how/desktop/tenth/car.png" alt="">
		
		<!-- floor -->
		<div class="floorM another"></div>
		
		<!-- floor -->
		<div class="floorM light middle"></div>
	</div>
</div>

